//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '../utils/create';
import { props } from './props';
import EggItem from './EggItem.js'
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "egg-config"
  }, _vm._l(_vm.eggIds, function (ref, idx) {
    var type = ref.type;
    var eggId = ref.eggId;
    return _c('EggItem', {
      key: eggId,
      attrs: {
        "type": type,
        "egg-id": eggId,
        "sort": _vm.sort,
        "is-preview": _vm.isPreview,
        "egg-columns": _vm.eggColumns,
        "formatter": _vm.dataFormatter
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function (ref) {
          var eggName = ref.eggName;
          var eggPrice = ref.eggPrice;
          return [_vm._t("title", null, {
            "eggName": eggName,
            "eggPrice": eggPrice
          })];
        }
      }], null, true)
    }, [_vm._v(" "), idx !== _vm.eggIds.length - 1 ? _c('span', {
      attrs: {
        "slot": "separate"
      },
      slot: "separate"
    }) : _vm._e()]);
  }), 1);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-0d614cc2',
  render,
  name: 'CbEggConfig',
  components: {
    EggItem
  },
  props,
  computed: {
    eggIds() {
      // 合并录播和包房彩蛋，统一渲染
      return [...this.roomEggs.map(v => {
        return {
          type: 'room',
          eggId: v
        };
      }), ...this.workEggs.map(v => {
        return {
          type: 'work',
          eggId: v
        };
      })];
    }
  }
});